<template>
  <div
    v-loading.fullscreen="showLoading"
    class="live-commentary-voucher"
  >
    <!-- 红包类型  1限时 2限量 3无限制 -->
    <div class="live-commentary-voucher-top">
      <div
        v-if="data.commentaryText.voucherType===1"
        class="live-commentary-voucher-num"
      >
        <span :class="['big',{ disabled }]">{{ leftTime }}</span> left
      </div>
      <div
        v-else-if="data.commentaryText.voucherType===2"
        class="live-commentary-voucher-num"
      >
        <span :class="['big',{ disabled }]">{{ leftCount }}/</span> {{ data.commentaryText.voucherTotalCount }} left
      </div>
      <div
        v-else
        class="live-commentary-voucher-num"
      >
        {{ $t('CURRENCY') }} <span :class="['big',{ disabled }]">{{ formatAmount }}</span>
      </div>
      <a
        :class="['live-commentary-voucher-open',{
          disabled
        }]"
        @click="handleOpen"
      >
        {{ buttonText }}
      </a>
    </div>

    <!-- 红包标题 -->
    <div class="live-commentary-voucher-bot">
      {{ data.commentaryText.voucherPlanName }}
    </div>
    <div class="live-commentary-voucher-semicircles">
      <span class="left top" />
      <span class="left bottom" />
      <span class="right top" />
      <span class="right bottom" />
    </div>

    <BottomBarClose />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@ms/stores/auth'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import { fetchVoucherPlanDistributionCount, claimEventVoucher } from '@ms/api/voucher'
import eventBus from '@ms/utils/event-bus.js'
import SlideLeftFixed from '../config/slideLeftFixed.mixin.js'
import BottomBarClose from './BottomBarClose.vue'
import 'base/icons/svg/close.svg'

export default {
  name: 'MsgVoucher',
  components: {
    BottomBarClose
  },
  mixins: [SlideLeftFixed],
  inheritAttrs: false, // 不回退defaultMarkets为 attr
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { currentFixedType, currentFixedId, event } = storeToRefs(matchDetailStore)

    return {
      currentFixedType,
      currentFixedId,
      event
    }
  },
  data() {
    return {
      voucherUsed: 0,
      voucherTotal: 0,
      leftTime: '',
      timerUsed: '',
      timerLeft: '',
      isFinished: false, // 已结束
      awarded: false, // 已领取
      isOnce: false,
      fixedLeftTime: 300,
      showLoading: false
    }
  },
  computed: {
    voucherStatus() {
      // 0 可点击 1 已结束 2 已领取
      if (this.awarded) return 2
      if (this.isFinished) {
        return 1
      } else {
        return 0
      }
    },
    disabled() {
      return !!this.voucherStatus
    },
    buttonText() {
      const { voucherType } = this.data.commentaryText

      if (this.voucherStatus === 0) {
        return 'Click to Open'
      } else if (this.voucherStatus === 2) {
        return 'Awarded'
      } else {
        if (voucherType === 1) {
          return "Time's Up"
        } else {
          return 'Finished'
        }
      }
    },
    formatAmount() {
      const amount = this.data.commentaryText.voucherPackageValue || 0
      if (amount) {
        return (amount / 10000).toFixed(2)
      } else {
        return '0.00'
      }
    },
    leftCount() {
      const { voucherTotal, voucherUsed } = this
      const left = voucherTotal - voucherUsed
      return left < 0 ? 0 : left
    },
    limitTime() {
      const { voucherType } = this.data.commentaryText
      if (this.data.isPushMsg) {
        if (this.isFinished) {
          return 0
        } else if (voucherType === 1) {
          const time = this.leftTime.split(':')
          const m = +time[0]
          const s = +time[1]
          return m * 60 + s
        } else {
          return 5 * 60
        }
      } else {
        return 0
      }
    },
    showFixed() {
      const { voucherType } = this.data.commentaryText
      const time = voucherType === 1 ? this.limitTime : this.fixedLeftTime
      return !!(this.voucherStatus === 0 && time && this.currentFixedType <= 4 && this.data.isPushMsg && this.isBottom)
    }
  },
  mounted() {
    const { voucherType } = this.data.commentaryText
    if (voucherType === 2) {
      const { voucherTotalCount, voucherUsedCount } = this.data.commentaryText
      this.voucherUsed = voucherUsedCount || 0
      this.voucherTotal = voucherTotalCount || 0
      if (voucherUsedCount === voucherTotalCount) {
        this.isFinished = true
      } else {
        this.checkLeftCount()
      }
    } else if (voucherType === 1) {
      this.checkLeftTime()
    }
  },
  beforeDestroy() {
    clearInterval(this.timerLeft)
    clearInterval(this.timerUsed)
  },
  methods: {
    compPriority() {
      return this.currentFixedType <= 4
    },
    checkLeftCount() {
      this.timerUsed = setInterval(() => {
        const { voucherPlanId } = this.data.commentaryText
        fetchVoucherPlanDistributionCount(voucherPlanId)
          .then((res) => {
            this.voucherUsed = res.used || 0
            this.voucherTotal = res.total || 0
            if (this.voucherUsed === this.voucherTotal) {
              clearInterval(this.timerUsed)
              this.isFinished = true
            }
          })
          .catch(console.error)
      }, 60000)
    },
    checkLeftTime() {
      this.timerLeft = setInterval(() => {
        const endTime = this.data.commentaryText.endTime || Date.now()
        const startTime = Date.now()
        if (startTime >= endTime) {
          clearInterval(this.timerLeft)
          this.leftTime = '00:00'
          this.isFinished = true
        } else {
          const leftMinutes = dayjs(endTime).diff(startTime, 'minute')
          const leftSeconds = dayjs(endTime).diff(startTime, 'second')
          const sString = leftSeconds < 10 ? `0${leftSeconds}` : leftSeconds
          this.leftTime = `${leftMinutes}:${sString}`
        }
      }, 1000)
    },
    async handleOpen() {
      if (this.disabled) return
      try {
        if (!useAuthStore().loginStatus) {
          return this.$login()
        }
        this.showLoading = true
        const { voucherPlanId } = this.data.commentaryText
        const { bizCode, data, message } = await claimEventVoucher(this.event.eventId, voucherPlanId)
        this.showLoading = false
        // 需要判断状态码
        if (bizCode === 10000) {
          // 成功 弹红包弹窗
          // 弹窗内存有问题，暂时关闭领取红包弹窗，剩推送红包弹窗使用
          // this.$dialog({
          //   message: this.$createElement(PopupVoucher, {
          //     props: {
          //       data: { ...data.event, closeOnUse: true }, visible: true
          //     }
          //   }),
          //   showClose: false,
          //   dangerouslyUseHTMLString: true
          // }).catch(console.log)
          if (data.sendable === false) this.awarded = true
          const { voucherType } = this.data.commentaryText
          if (voucherType === 2) {
            this.voucherUsed = data.used
            this.voucherTotal = data.total
            if (this.voucherUsed === this.voucherTotal) {
              clearInterval(this.timerUsed)
              this.isFinished = true
            }
          }
          eventBus.$emit('update-bet-vouchers')
        } else if (bizCode === 19001) {
          // 只一次
          this.popMessage(message)
          this.awarded = true
        } else if (bizCode === 19005) {
          // 已抢完
          this.popMessage(message)
          this.voucherUsed = this.voucherTotal
          this.timerUsed && clearInterval(this.timerUsed)
          this.isFinished = true
        } else if (bizCode === 19006) {
          // 已结束
          this.popMessage(message)
          this.isFinished = true
        } else {
          this.popMessage(message)
        }
      } catch (e) {
        this.showLoading = false
        this.popMessage(e.message)
      }
    },
    popMessage(msg) {
      this.$dialog({
        message: msg,
        showClose: false,
        confirmButtonText: 'OK',
        cancelButtonText: ''
      }).catch(console.log)
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-voucher {
  position: relative;
  box-sizing: border-box;
  padding: 10/@rem 15/@rem;
  border-radius: 4/@rem;
  background-color: @major;
  font-size: 12/@rem;
  transform: translateX(0);

  &-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-num {
    color: @white;

    .big {
      color: @primary;
      font-size: 30/@rem;
    }

    .disabled {
      color: @white;
    }
  }

  &-open {
    display: block;
    height: 20/@rem;
    padding: 0 7/@rem;
    border-radius: 20/@rem;
    background-color: @primary;
    color: @major;
    line-height: 20/@rem;
    white-space: nowrap;

    &.disabled {
      background-color: @gray;
      cursor: not-allowed;
    }
  }

  &-bot {
    margin: 3/@rem 0;
    color: @white;
  }

  &-semicircles {
    overflow: hidden;

    span {
      position: absolute;
      width: 12/@rem;
      height: 12/@rem;
      border-radius: 50%;
      background-color: @mask;
    }

    .left {
      left: -6/@rem;
    }

    .right {
      right: -6/@rem;
    }

    .top {
      top: 18%;
    }

    .bottom {
      bottom: 18%;
    }
  }

  &.fixed-bottom {
    position: fixed;
    z-index: 10;
    right: 0;
    bottom: 70/@rem;
    left: 0;
    width: 296/360 *100%;
    border-radius: 4px;
    margin: auto;
    box-shadow: 0 0/@rem 12/@rem 15/@rem @dark;
    transform: translateX(-100%);

    .bottom-bar-close {
      display: flex;
    }

    .live-commentary-voucher-semicircles span {
      background-color: @dark;
    }
  }
}
</style>
